import React from 'react';

import type { LinkPreviewNode } from './../../ricos-schema/next-schema';
import type { PluginProps } from './../../ricos-types';

import { linkPreviewConverter } from '../link-preview-converter';
import { LinkPreviewViewer } from '../viewer/link-preview-viewer';

export const LinkPreview: React.FC<PluginProps> = ({ node }) => {
  const ricosNode = React.useMemo(() => linkPreviewConverter.fromPm.convert(node.toJSON()), [node]);

  return <LinkPreviewViewer node={ricosNode as LinkPreviewNode} />;
};
